var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAcConnector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5801_190959)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.457 27.5H90.9008C100.008 27.5 107.397 34.9417 107.397 44.1298V92.9541C107.397 102.142 100.008 109.584 90.9008 109.584H42.457C33.35 109.584 25.9606 102.142 25.9606 92.9541V44.1298C25.9606 34.9417 33.35 27.5 42.457 27.5Z",
    fill: "#F0F2F4",
    stroke: "#30BD6F"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_5801_190959)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8841 88.3674C63.7331 87.3884 66.7272 87.3884 68.5719 88.3674C69.4964 88.859 69.9544 89.5002 69.9544 90.1457V130.491C69.9544 131.132 69.4922 131.773 68.5719 132.265C66.7272 133.248 63.7331 133.248 61.8841 132.265C60.9596 131.773 60.4974 131.132 60.4974 130.491V90.1457C60.4974 89.5044 60.9596 88.859 61.8841 88.3674Z",
    fill: "#7B909B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1725 88.3674C63.8603 87.3884 66.5957 87.3884 68.2793 88.3674C69.1232 88.859 69.5431 89.5002 69.5431 90.1457V130.491C69.5431 131.132 69.1232 131.773 68.2793 132.265C66.5914 133.248 63.8561 133.248 62.1725 132.265C61.3286 131.773 60.9087 131.132 60.9087 130.491V90.1457C60.9087 89.5044 61.3286 88.859 62.1725 88.3674Z",
    fill: "url(#paint0_linear_5801_190959)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3947 100.918L60.9087 98.8875V92.6977C60.9087 92.0564 61.3286 91.411 62.1725 90.9194C63.8603 89.9405 66.5957 89.9405 68.2793 90.9194C69.1232 91.411 69.5431 92.0522 69.5431 92.6977V97.9129L64.3905 100.914L64.3947 100.918Z",
    fill: "black"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3651 93.6338V89.3591L56.3541 88.2006L54.3651 87.055V84.4089L56.3541 83.2505L54.3651 82.1048V79.4416L56.3541 78.2832L54.3651 77.1461V74.3119L56.3541 73.1535L54.3651 72.0079V59.3802L63.5932 64.6724L66.4176 63.0309L79.437 59.4273L79.7635 60.2138L77.9951 61.2398V65.9377L74.7975 67.7972V70.9734L72.7958 72.1404L74.7975 73.2561V75.9278L72.7916 77.1034L74.7975 78.2191V80.9421L72.8043 82.0663L74.7975 83.1778V85.8495L72.7916 87.0122L74.7975 88.1322V92.4112L63.5974 98.9302L54.3651 93.6338Z",
    fill: "#7B909B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5338 98.4514L74.3098 92.1804V88.3972L71.8671 87.0378L74.3098 85.6186V83.4471L71.8671 82.0877L74.3098 80.7069V78.4883L71.8671 77.129L74.3098 75.7012V73.5211L71.8671 72.1617L74.3098 70.7425V67.5664L77.5116 65.7068V34.42L66.5194 31.6243V63.4455L63.5338 65.1768V73.8374V98.4514Z",
    fill: "#DADFE3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7256 60.1283L63.5338 65.1768V98.4514L54.7256 93.4029V89.6198L57.1429 88.2134L54.7256 86.8241V84.6696L57.1429 83.2632L54.7256 81.8739V79.7024L57.1429 78.296L54.7256 76.911V74.5727L57.1429 73.1663L54.7256 71.777V60.1283Z",
    fill: "#CCD4D6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5338 94.6725L74.3098 88.3972L71.8671 87.0378L63.5338 91.8897V94.6725Z",
    fill: "#A7ACB0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5338 89.7181L74.3098 83.447L71.8671 82.0876L63.5338 86.9395V89.7181Z",
    fill: "#A7ACB0"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5338 84.7595L74.3098 78.4884L71.8671 77.129L63.5338 81.9809V84.7595Z",
    fill: "#A7ACB0"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5338 79.6255L74.3098 73.5211L71.8671 72.1617L63.5338 76.8426V79.6255Z",
    fill: "#A7ACB0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7111 91.3297L54.7256 89.6198L57.1429 88.2134L57.7111 88.5383V91.3297Z",
    fill: "#A7ACB0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M62.533 91.3297L63.5338 91.8897V94.6726L60.1115 92.7062L62.533 91.3297Z",
    fill: "#A7ACB0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5669 86.3795L63.5338 86.9395V89.7181L60.1115 87.756L62.5669 86.3795Z",
    fill: "#A7ACB0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7111 86.3796L54.7256 84.6697L57.1429 83.2633L57.7111 83.5882V86.3796Z",
    fill: "#A7ACB0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7111 81.4166L54.7256 79.7024L57.1429 78.296L57.7111 78.6209V81.4166Z",
    fill: "#A7ACB0"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5669 81.4165L63.5338 81.9722V84.7551L60.1115 82.7887L62.5669 81.4165Z",
    fill: "#A7ACB0"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6984 76.3595L63.5338 76.8425V79.6254L60.1115 77.659L62.6984 76.3595Z",
    fill: "#A7ACB0"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7111 76.2825L54.7256 74.5726L57.1429 73.1663L57.7111 73.4911V76.2825Z",
    fill: "#A7ACB0"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M62.533 91.3297L60.1115 92.7404V89.9575L62.533 91.3297Z",
    fill: "#81868A"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5669 86.3795L60.1115 87.7731V84.9902L62.5669 86.3795Z",
    fill: "#81868A"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5669 81.4165L60.1115 82.8058V80.0229L62.5669 81.4165Z",
    fill: "#81868A"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6984 76.3596L60.1115 77.6591V74.8719L62.6984 76.3596Z",
    fill: "#81868A"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5194 31.6243L77.5116 34.42L68.6992 29.3715L57.7112 26.5715L66.5194 31.6243Z",
    fill: "#E7ECF0"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2903 34.7919V61.3808L74.3098 60.1967V33.6078L76.2903 34.7919Z",
    fill: "#DADFE3"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4879 35.6041V59.859L76.2903 61.7185V34.7919L79.4879 35.6041Z",
    fill: "#CDD2D6"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2903 34.9287L79.4879 35.6041L77.5116 34.42L74.3098 33.6078L76.2903 34.9287Z",
    fill: "#E7ECF0"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2701 71.3154C54.8231 71.3154 52.2065 70.6528 49.4881 69.349L45.6459 67.109C39.4034 62.8257 33.7292 55.7339 30.0821 47.6461L30.0439 47.5606V36.6856L26.0787 34.3815V27.2299L30.0439 24.9386V18.6205L30.1626 18.4966C30.6376 17.9964 31.1635 17.539 31.7275 17.1372L32.0965 16.8764L57.0411 2.47479C58.7289 1.49587 60.6585 1 62.7789 1C65.2174 1 67.8298 1.65831 70.5397 2.95356L74.3861 5.18498C80.6753 9.48965 86.375 16.6285 90.0306 24.7762L90.0687 24.8617V35.6212L94.0042 37.9125V45.0641L90.0687 47.334V53.6478L89.9542 53.7718C89.1146 54.6652 88.1561 55.3962 87.1044 55.9476L63.4108 69.5969C61.6297 70.7425 59.5729 71.3154 57.2701 71.3154Z",
    fill: "#7B909B"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5579 27.4479L30.5231 29.7562L54.997 15.641L51.0318 13.3326L26.5579 27.4479Z",
    fill: "#F3F4F6"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2441 27.3196L30.2093 29.628V18.6333C33.7165 14.9442 39.2677 14.256 45.6248 17.2953L49.4118 19.4968C55.8113 23.8742 61.3964 31.0814 64.9079 38.9085V49.8219L68.8434 52.1132V58.7732L64.9079 56.482V67.4339C61.3964 71.1743 55.8113 71.8796 49.4076 68.8104L45.6205 66.6046C39.2635 62.2443 33.7122 55.0927 30.2051 47.3169V36.2881L26.2399 33.984V27.3239L26.2441 27.3196Z",
    fill: "#7B909B"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1513 70.563C54.8274 70.563 52.3295 69.9303 49.7214 68.6778L45.964 66.4892C39.8911 62.3255 34.3441 55.3919 30.7564 47.4793V36.2966L26.7912 33.9925V28.3199L30.7564 30.6283V19.0651C32.6817 17.103 35.2432 16.0685 38.1693 16.0685C40.4848 16.0685 42.97 16.6969 45.5654 17.9408L49.3228 20.1252C55.438 24.3102 61.0147 31.2823 64.6067 39.259V50.3263L68.5422 52.6176V58.2902L64.6067 55.9989V67.5194C62.6729 69.5114 60.0987 70.5673 57.1429 70.5673L57.1513 70.563Z",
    fill: "#DADFE3"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2259 49.9502L69.1614 52.2415L93.6353 38.1262L89.6998 35.835L65.2259 49.9502Z",
    fill: "#F3F4F6"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2259 49.9502V39.0325L89.6998 24.9172V35.8349L65.2259 49.9502Z",
    fill: "#BDC4C9"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3083 2.81677C60.7349 0.829016 65.315 0.867488 70.4125 3.30837L74.1995 5.50987C80.599 9.88721 86.1841 17.0944 89.6956 24.9215L65.2217 39.0367C61.7102 31.2097 56.1251 24.0024 49.7256 19.6251L45.9386 17.4236C40.8156 14.9742 36.2143 14.9485 32.7877 16.9619L57.3083 2.81677Z",
    fill: "url(#paint1_linear_5801_190959)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2259 67.5578V56.6059L69.1614 58.8972L89.6998 47.0519V53.4426C88.894 54.3019 87.9738 55.0029 86.9644 55.533L63.2581 69.1908C63.9706 68.7334 64.6322 68.1948 65.2301 67.5536L65.2259 67.5578Z",
    fill: "url(#paint2_linear_5801_190959)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1614 58.9015V52.2414L93.6353 38.1262V44.782L69.1614 58.9015Z",
    fill: "#CDD2D6"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0419 53.2973C60.0224 54.4472 61.6339 53.5111 61.6339 51.207C61.6339 48.9029 60.0224 46.0901 58.0419 44.9359C56.0614 43.7817 54.4499 44.7179 54.4499 47.0263C54.4499 49.3304 56.0614 52.1431 58.0419 53.2973Z",
    fill: "#2E383B"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6647 41.4349C39.6452 42.5891 41.2524 41.6486 41.2524 39.3445C41.2524 37.0404 39.6409 34.2277 37.6647 33.0778C35.6842 31.9236 34.0727 32.8597 34.0727 35.1681C34.0727 37.4722 35.6842 40.285 37.6647 41.4392V41.4349Z",
    fill: "#2E383B"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0522 19.514L46.2651 17.3125C45.048 16.7311 43.8648 16.2865 42.7155 15.9788V31.9278L52.6518 37.7116V21.7155L57.1725 19.0309V18.7445L50.0564 19.5225L50.0522 19.514Z",
    fill: "#64656B"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7833 13.2771L57.1683 18.7402L52.2956 21.5744C52.2956 21.5744 52.3168 21.5915 52.3253 21.6V37.8184L42.389 32.0347V16.0856L47.7791 13.2771H47.7833Z",
    fill: "url(#paint3_linear_5801_190959)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3593 32.5177C49.3058 33.6505 50.8876 32.7315 50.8876 30.4659C50.8876 28.2002 49.3058 25.4388 47.3593 24.3102C45.4169 23.1774 43.8351 24.1008 43.8351 26.3621C43.8351 28.6234 45.4169 31.3849 47.3593 32.5177Z",
    fill: "url(#paint4_linear_5801_190959)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3593 32.1074C49.1107 33.1248 50.5314 32.2997 50.5314 30.2607C50.5314 28.2216 49.1107 25.7423 47.3593 24.7206C45.612 23.7032 44.1871 24.5325 44.1871 26.5673C44.1871 28.6021 45.612 31.09 47.3593 32.1074Z",
    fill: "#2E383B"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7029 68.2974C31.1762 68.2974 29.7513 67.4681 28.9922 66.1386C28.4197 65.1384 28.267 63.9756 28.5639 62.8642C28.8607 61.7528 29.5689 60.8209 30.5613 60.2438L55.1751 45.9191C55.7095 45.607 56.3159 45.4446 56.9308 45.4446C58.1819 45.4446 59.3524 46.1243 59.9758 47.2143L60.7434 48.5566C61.2141 49.3773 61.3371 50.3306 61.0953 51.2454C60.8536 52.1602 60.2726 52.9211 59.4584 53.3956L34.8445 67.7203C34.1915 68.1008 33.4535 68.2974 32.7072 68.2974H32.7029Z",
    fill: "#2E383B"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7681 60.6112L55.3824 46.2865C56.8588 45.4273 58.7474 45.9374 59.5998 47.4256L60.3695 48.7694C61.2219 50.2576 60.7159 52.1613 59.2395 53.0205L34.6252 67.3452C32.7815 68.4182 30.4179 67.7798 29.3535 65.9214C28.289 64.0629 28.9223 61.6804 30.766 60.6075L30.7681 60.6112Z",
    fill: "url(#paint5_linear_5801_190959)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.1183 53.4238L43 53.5L47.3721 59.9269L59.2395 53.0205C60.7159 52.1613 61.2219 50.2576 60.3695 48.7694L59.5998 47.4256C58.7474 45.9373 56.8589 45.4273 55.3824 46.2865L43.1183 53.4238Z",
    fill: "url(#paint6_linear_5801_190959)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2875 56.4307C10.7608 56.4307 9.33587 55.6014 8.57676 54.2719C7.39781 52.2115 8.10179 49.5654 10.1459 48.3728L34.7597 34.0481C35.2941 33.736 35.9005 33.5736 36.5112 33.5736C37.7622 33.5736 38.9327 34.2533 39.5561 35.3434L40.3279 36.6856C40.7987 37.5064 40.9216 38.4596 40.6799 39.3744C40.4382 40.2892 39.8572 41.0501 39.043 41.5246L14.4291 55.8493C13.776 56.2298 13.0381 56.4264 12.2917 56.4264L12.2875 56.4307Z",
    fill: "#2E383B"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3525 48.7441L34.9668 34.4194C36.4432 33.5602 38.3318 34.0703 39.1842 35.5585L39.9539 36.9023C40.8063 38.3906 40.3003 40.2942 38.8239 41.1534L14.2096 55.4781C12.3659 56.5511 10.0023 55.9127 8.93787 54.0543C7.87342 52.1959 8.50674 49.8134 10.3504 48.7404L10.3525 48.7441Z",
    fill: "url(#paint7_linear_5801_190959)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.4559 39.851C40.2497 40.154 39.9816 40.4167 39.6483 40.619L27.2768 47.8671L22.9528 41.651L35.3824 34.4173C36.8588 33.5581 38.7474 34.0682 39.5998 35.5564L40.3695 36.9003C40.9082 37.8408 40.9043 38.9472 40.4559 39.851Z",
    fill: "url(#paint8_linear_5801_190959)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5801_190959",
    x1: 60.9087,
    y1: 110.318,
    x2: 69.5473,
    y2: 110.318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3E3E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#E9EAEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FBFDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDC3C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5801_190959",
    x1: 32.7877,
    y1: 20.215,
    x2: 89.6998,
    y2: 20.215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFCFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#F4F5F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#E0E4E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6DCE0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5801_190959",
    x1: 63.2539,
    y1: 58.1235,
    x2: 89.6998,
    y2: 58.1235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFCFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#F4F5F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#E0E4E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6DCE0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5801_190959",
    x1: 53.2837,
    y1: 16.6114,
    x2: 43.6617,
    y2: 33.1396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1ACB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#96A0A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#90999C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#8F979A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#91999C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#9BA3A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#ABB3B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#C1C9CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#DEE6E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#F3FBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#EBF3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#C2C8CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#A0A4A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#85888D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#73747A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#67686E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#64656B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5801_190959",
    x1: 48.4152,
    y1: 23.6605,
    x2: 46.0213,
    y2: 34.3008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#636B70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#5B5F61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#575858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#565656"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#8F979A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#91999C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#9BA3A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#ABB3B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#C1C9CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#DEE6E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#F3FBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EBF3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#C2C8CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#A0A4A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#85888D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#73747A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#67686E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#64656B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5801_190959",
    x1: 31.5,
    y1: 60,
    x2: 35.4515,
    y2: 67.0273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#B9B9B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#A2A2A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#EDEDED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#B1B1B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#6D6D6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#616161"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_5801_190959",
    x1: 45.0193,
    y1: 52.5397,
    x2: 48.287,
    y2: 58.3241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDBDBD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_5801_190959",
    x1: 11.0844,
    y1: 48.1329,
    x2: 15.0359,
    y2: 55.1602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#B9B9B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#A2A2A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#EDEDED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#B1B1B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#6D6D6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#616161"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_5801_190959",
    x1: 24.9753,
    y1: 40.6707,
    x2: 28.2383,
    y2: 46.463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDBDBD"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5801_190959"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 110,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_5801_190959"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 86,
    height: 132,
    fill: "white",
    transform: "translate(8 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcConnector);
export default __webpack_public_path__ + "static/media/ac_connector.0a32dae00ada8f17927e51642275ac61.svg";
export { ForwardRef as ReactComponent };